import React, { PropsWithChildren } from 'react';

import styles from './dictionary-components.module.scss';

export default function AkBold({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkBold}>{children}</span>;
}
